// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","externalLinkModal":"_3pEOS_qHHk0D97wAtDSZP2","externalLink":"_3AbXRNOkDupR8Vgwk6OJh3"};